module.exports = __webpack_public_path__ + "static/media/eng_d_2413.3e285e27.vtt";